// extracted by mini-css-extract-plugin
export default {"timerBar":"TimerBar_timerBar__g-ndU","content":"TimerBar_content__RUEjN","large":"TimerBar_large__pac7K","medium":"TimerBar_medium__zn2oe"};